import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { Fragment } from 'react';
import styled from 'styled-components';
import '../../../../utils/assertions.es.js';
import { runIfFn } from '../../../../utils/functions.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import { spacing, color } from '../../../../utils/theme.es.js';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import { List } from '../../../List/List.es.js';
import { Box } from '../../../../primitives/Box/Box.es.js';
import { Center } from '../../../../primitives/Center/Center.es.js';
import { Progress } from '../../../Progress/Progress.es.js';
import { useAutocompleteDropdown } from './AutocompleteContext.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var BottomComponent = styled(Box).withConfig({
  componentId: "lpm3oq-0"
})(["flex:1 0 auto;position:sticky;bottom:-", ";background-color:", ";margin-bottom:-", ";"], spacing("xs"), color("surface"), spacing("xs"));

var DefaultLoadingComponent = function DefaultLoadingComponent() {
  return (
    /* @__PURE__ */
    React.createElement(Center, {
      py: "md"
    },
    /* @__PURE__ */
    React.createElement(Progress, {
      size: "md"
    }))
  );
};

function ItemsContent(props) {
  var itemProps = props.itemProps,
      itemComponent = props.itemComponent,
      _props$showNoResults = props.showNoResults,
      showNoResults = _props$showNoResults === void 0 ? true : _props$showNoResults,
      NoResultsComponent = props.noResultsComponent,
      noResultsLabel = props.noResultsLabel,
      highlightedIndex = props.highlightedIndex,
      getItemsLabel = props.getItemsLabel,
      isLoading = props.isLoading,
      _props$loadingCompone = props.loadingComponent,
      LoadingComponent = _props$loadingCompone === void 0 ? DefaultLoadingComponent : _props$loadingCompone,
      bottomComponent = props.bottomComponent;

  var _useAutocompleteDropd = useAutocompleteDropdown(),
      items = _useAutocompleteDropd.items,
      isOpen = _useAutocompleteDropd.isOpen,
      isGrouped = _useAutocompleteDropd.isGrouped,
      getDisabledOption = _useAutocompleteDropd.getDisabledOption,
      hasReachedMaxValues = _useAutocompleteDropd.hasReachedMaxValues,
      inputValue = _useAutocompleteDropd.inputValue,
      closeMenu = _useAutocompleteDropd.closeMenu;

  if (isLoading) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null,
      /* @__PURE__ */
      React.createElement(LoadingComponent, null), bottomComponent &&
      /* @__PURE__ */
      React.createElement(BottomComponent, null, runIfFn(bottomComponent, {
        inputValue: inputValue,
        closeMenu: closeMenu
      })))
    );
  }

  if (items.length <= 0 && !isLoading) {
    return showNoResults ?
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(NoResultsComponent, null, noResultsLabel), bottomComponent &&
    /* @__PURE__ */
    React.createElement(BottomComponent, null, runIfFn(bottomComponent, {
      inputValue: inputValue,
      closeMenu: closeMenu
    }))) : null;
  }

  var renderGroups = function renderGroups() {
    return items.reduce(function (acc, item, index) {
      acc.groups.push(
      /* @__PURE__ */
      React.createElement(Fragment, {
        key: "group-" + index
      },
      /* @__PURE__ */
      React.createElement(List.Subheader, null, item.group), item.options.map(function (option) {
        var optionIndex = acc.itemIndex++;
        return (
          /* @__PURE__ */
          React.createElement(List.Item, __spreadValues({
            key: "option-" + optionIndex,
            isSelected: highlightedIndex === optionIndex,
            isDisabled: (getDisabledOption == null ? void 0 : getDisabledOption(item)) || hasReachedMaxValues
          }, itemProps({
            item: option,
            index: optionIndex
          })), itemComponent({
            item: option,
            getItemsLabel: getItemsLabel,
            closeMenu: closeMenu
          }))
        );
      })));
      return acc;
    }, {
      groups: [],
      itemIndex: 0
    }).groups;
  };

  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return (
        /* @__PURE__ */
        React.createElement(List.Item, __spreadValues({
          isSelected: highlightedIndex === index,
          key: "option-" + index,
          isDisabled: (getDisabledOption == null ? void 0 : getDisabledOption(item)) || hasReachedMaxValues
        }, itemProps({
          item: item,
          index: index
        })), itemComponent({
          item: item,
          getItemsLabel: getItemsLabel,
          closeMenu: closeMenu
        }))
      );
    });
  };

  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, isOpen && (isGrouped ? renderGroups() : renderItems()), bottomComponent &&
    /* @__PURE__ */
    React.createElement(BottomComponent, null, runIfFn(bottomComponent, {
      inputValue: inputValue,
      closeMenu: closeMenu
    })))
  );
}

var Items = forwardRef(function (props, ref) {
  var _a = props,
      itemProps = _a.itemProps,
      itemComponent = _a.itemComponent,
      _a$showNoResults = _a.showNoResults,
      showNoResults = _a$showNoResults === void 0 ? true : _a$showNoResults,
      noResultsComponent = _a.noResultsComponent,
      noResultsLabel = _a.noResultsLabel,
      highlightedIndex = _a.highlightedIndex,
      getItemsLabel = _a.getItemsLabel,
      isLoading = _a.isLoading,
      loadingComponent = _a.loadingComponent,
      bottomComponent = _a.bottomComponent,
      rest = __objRest(_a, ["itemProps", "itemComponent", "showNoResults", "noResultsComponent", "noResultsLabel", "highlightedIndex", "getItemsLabel", "isLoading", "loadingComponent", "bottomComponent"]);

  return (
    /* @__PURE__ */
    React.createElement(List, __spreadValues({
      as: "div",
      flex: "1 1 auto",
      overflowY: "auto",
      py: "xs",
      position: "relative",
      ref: ref
    }, rest),
    /* @__PURE__ */
    React.createElement(ItemsContent, {
      itemProps: itemProps,
      itemComponent: itemComponent,
      showNoResults: showNoResults,
      noResultsComponent: noResultsComponent,
      noResultsLabel: noResultsLabel,
      highlightedIndex: highlightedIndex,
      getItemsLabel: getItemsLabel,
      isLoading: isLoading,
      loadingComponent: loadingComponent,
      bottomComponent: bottomComponent
    }))
  );
});
export { Items, ItemsContent };